"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayReportEventEntity = void 0;
class DisplayReportEventEntity {
    _id;
    id;
    timestamp;
    metadata;
    category;
    type;
    severity;
    source;
}
exports.DisplayReportEventEntity = DisplayReportEventEntity;
